(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/progress-bar/assets/javascripts/progress-bar.js') >= 0) return;  svs.modules.push('/components/lb-ui/progress-bar/assets/javascripts/progress-bar.js');
"use strict";

const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect;
const ProgressBar = _ref => {
  let _ref$minValue = _ref.minValue,
    minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? 100 : _ref$maxValue,
    _ref$currValue = _ref.currValue,
    currValue = _ref$currValue === void 0 ? 0 : _ref$currValue,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  const totalValue = maxValue - minValue;
  let percentProgress = 0;
  if (currValue >= minValue && currValue <= maxValue) {
    percentProgress = currValue / totalValue * 100;
  }
  const percentBar = useRef(null);
  useEffect(() => {
    if (percentBar.current) {
      percentBar.current.style.width = percentProgress.toString().concat('%');
    }
  }, [percentBar, percentProgress]);
  const classnames = ['pg-progress-bar'];
  if (className) {
    classnames.push(className);
  }
  return React.createElement("div", {
    className: classnames.join(' ')
  }, React.createElement("div", {
    className: "pg-progress-bar-percent",
    ref: percentBar
  }));
};
setGlobal('svs.components.lbUi.progressBar.ProgressBar', ProgressBar);

 })(window);